import { IncentiveCampaignChallenge } from 'domains/loyalty.d';

export function getChallenges(challenges: IncentiveCampaignChallenge[]): {
  current: IncentiveCampaignChallenge | undefined;
  next: IncentiveCampaignChallenge | undefined;
} {
  const current = challenges.findLast((challenge) => challenge.completed);
  const currentIndex = current ? challenges.indexOf(current) : -1;

  let next = undefined;
  if (currentIndex < 0) {
    next = challenges[0];
  }

  if (currentIndex != challenges.length - 1) {
    next = challenges[currentIndex + 1];
  }

  return { current, next };
}
